module.exports = __webpack_public_path__ + "img/nantian.1234696b.png";